export const cmsMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/cms/websites',
    label: 'CMS',
    Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
            </g>
        </svg>

    ),

    subMenu: [

        {
            id: `coln-1-collections`,
            label: 'Websites',
            path: '/management/cms/websites',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.5 5c-.83 0-1.5.67-1.5 1.5V17c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V6.5c0-.83-.67-1.5-1.5-1.5H5.5zm13 1.5v10h-13v-10h13zM5.5 4h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.38-1.12 2.5-2.5 2.5h-13C4.12 19.5 3 18.38 3 17V6.5c0-1.38 1.12-2.5 2.5-2.5zm2 10.5V12h6v2.5H7.5zm0 3V15h6v2.5H7.5zm8-3V12h3.5v2.5H15.5zm0 3V15h3.5v2.5H15.5z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Web Pages',
            path: '/management/cms/web-pages',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M4 2h10l6 6v14H4V2zm2 2v16h12V9h-5V4H6zm2 4h8v2H8V8zm0 4h8v2H8v-2zm0 4h8v2H8v-2z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'EDocs',
            path: '/management/cms/e-docs',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm0 2h10v1H7v-1z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Templates',
            path: '/management/cms/templates',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm0 2h10v1H7v-1z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Templates Groups',
            path: '/management/cms/template-groups',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm0 2h10v1H7v-1z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),
        },
         {
            id: `coln-1-collections`,
            label: 'Brand Mappings',
            path: '/management/cms/brand-mappings',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" color="#ffffff" fill="none">
                    <path d="M12 2C16.8706 2 21 6.03298 21 10.9258C21 15.8965 16.8033 19.3847 12.927 21.7567C12.6445 21.9162 12.325 22 12 22C11.675 22 11.3555 21.9162 11.073 21.7567C7.2039 19.3616 3 15.9137 3 10.9258C3 6.03298 7.12944 2 12 2Z" stroke="currentColor" stroke-width="1.5" />
                    <path d="M12.6911 7.57767L13.395 8.99715C13.491 9.19475 13.7469 9.38428 13.9629 9.42057L15.2388 9.6343C16.0547 9.77141 16.2467 10.3682 15.6587 10.957L14.6668 11.9571C14.4989 12.1265 14.4069 12.4531 14.4589 12.687L14.7428 13.925C14.9668 14.9049 14.4509 15.284 13.591 14.7718L12.3951 14.0581C12.1791 13.929 11.8232 13.929 11.6032 14.0581L10.4073 14.7718C9.5514 15.284 9.03146 14.9009 9.25543 13.925L9.5394 12.687C9.5914 12.4531 9.49941 12.1265 9.33143 11.9571L8.33954 10.957C7.7556 10.3682 7.94358 9.77141 8.75949 9.6343L10.0353 9.42057C10.2473 9.38428 10.5033 9.19475 10.5993 8.99715L11.3032 7.57767C11.6872 6.80744 12.3111 6.80744 12.6911 7.57767Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        // {
        //   id: `coln-1-collections`,
        //   label: 'Templates',
        //   path: '/cms/templates',
        //   isEnabled:true,
        //  
        // },
        {
            id: `coln-1-collections`,
            label: 'Social Profiles',
            path: '/management/cms/social-profiles',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm4 4a5 5 0 1 0-8 0c0 2.21 1.79 4 4 4s4-1.79 4-4z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Announcements',
            path: '/management/cms/announcements',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 5H5V7h14v1zm-7 5v5h-2v-5H6l6-3.75 6 3.75h-4v5h-2v-5z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Help Topics',
            path: '/management/cms/help-topics',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 12H5V8h14v8zm-2-6H7v2h10V10z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Blog',
            path: '/management/cms/blog/blog-posts',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-3V8h3v2.5H15z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            isEnabled: true,
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Blog Post',
                    path: '/management/cms/blog/blog-posts',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-3V8h3v2.5H15z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Blog Request',
                    path: '/management/cms/blog/blog-requests',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 9h10v1H7V9zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-3V8h3v2.5H15z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                    isEnabled: true,

                }
            ]
        },
        {
            id: `coln-1-collections`,
            label: 'News Letter',
            path: '/management/cms/news-letter/news-letters',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3l-7 4.5L5 6v11h14V6zm-7 9h4v1h-4v-1zm0-2h4v1h-4v-1z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            isEnabled: true,
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'News Items',
                    path: '/management/cms/news-letter/news-letters',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3l-7 4.5L5 6v11h14V6zm-7 9h4v1h-4v-1zm0-2h4v1h-4v-1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Subscriptions ',
                    path: '/management/cms/news-letter/news-letter/subscriptions',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3l-7 4.5L5 6v11h14V6zm-7 9h4v1h-4v-1zm0-2h4v1h-4v-1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,

                }
            ]
        },

    ],
}
)
